/**
 * Created by r4zi4l on 21.06.2021
 */

const BoostTimeMissionWindow = CleverappsWindow.extend({
    onWindowLoaded: function (mission) {
        this.mission = mission;
        this.pack = BoostTimeMissionWindow.PACK;

        this._super({
            name: "BoostTimeMissionWindow",
            content: this.createContent(),
            title: Messages.get("BoostTimeMissionWindow.title"),
            noBackground: true,
            contentPadding: cleverapps.styles.BoostTimeMissionWindow.contentPadding,
            notCloseByTouchInShadow: true,
            closeButtonDelay: true
        });

        cleverapps.focusManager.showControlsWhileFocused(["MenuBarGoldItem", "MenuBarCoinsItem"]);
    },

    getPerson: function () {
        return cleverapps.styles.BoostTimeMissionWindow.person;
    },

    createContent: function () {
        const styles = cleverapps.styles.BoostTimeMissionWindow;

        const container = new cc.Node();
        container.setContentSize2(styles);
        container.setAnchorPoint(0.5, 0.5);

        if (bundles.boosttime.jsons.boost_time_json) {
            const animation = new cleverapps.Spine(bundles.boosttime.jsons.boost_time_json);
            animation.setAnimation(0, "animation", true);
            container.addChild(animation);
            animation.setAlignment(styles.animation);
        } else {
            const animation2 = new cc.Sprite(bundles.boosttime.frames.coins_animation);
            animation2.setAlignment(styles.animation);
            container.addChild(animation2);
        }

        const description = cleverapps.UI.generateOnlyText(Messages.get("BoostTimeMissionWindow.description"), cleverapps.styles.FONTS.BOOSTTIMEMISSIONWINDOW_DESCRIPTION_TEXT);
        description.setAlignment(styles.description);
        description.setDimensions(styles.description.width, 0);
        description.fitTo(undefined, styles.description.height);
        description.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        container.addChild(description);

        if (bundles.boosttime.frames.coins_pack) {
            const coinsPack = new cc.Sprite(bundles.boosttime.frames.coins_pack);
            container.addChild(coinsPack);
            coinsPack.setAlignment(styles.coinsPack);

            const coinsReward = new TextWithIcon(`@@x${this.pack.prizes.soft}`, {
                font: cleverapps.styles.FONTS.BOOSTTIMEMISSIONWINDOW_REWARD_TEXT
            });

            coinsReward.setAlignment(styles.coinsPack.reward);
            coinsPack.addChild(coinsReward);

            const badge = new cc.Sprite(bundles.badge.frames.badge_png);
            badge.setScale(0.7);
            const offerBadge = cleverapps.UI.generateOnlyText(Messages.get("BoostTimeMissionWindow.offerBadge"), cleverapps.styles.FONTS.BOOSTTIMEMISSIONWINDOW_BADGE_TEXT);
            badge.addChild(offerBadge);
            offerBadge.setAlignment(badge.width / 2, badge.height / 2);

            coinsPack.addChild(badge);
            badge.setAlignment(styles.coinsPack.badge);
        }

        const packTitle = this.createPackTitle();
        container.addChild(packTitle);

        const buyPackButton = new UseGoldButton({
            price: this.pack.price,
            eventName: `${cleverapps.EVENTS.SPENT.OFFER}_${this.mission.getName()}`,
            onClicked: this.buyPackProduct.bind(this),
            width: styles.buyPackButton.width,
            height: styles.buyPackButton.height
        });
        buyPackButton.setAlignment(styles.buyPackButton);
        container.addChild(buyPackButton);

        return container;
    },

    createPackTitle: function () {
        const styles = cleverapps.styles.BoostTimeMissionWindow;

        const title = cleverapps.UI.generateOnlyText(Messages.get("BoostTimeMissionWindow.packTitle"), cleverapps.styles.FONTS.BOOSTTIMEMISSIONWINDOW_TITLE_TEXT);
        title.fitTo(styles.ribbon.title.width);
        title.setAlignment(styles.ribbon.title);

        if (!bundles.boosttime.frames.purple_ribbon) {
            console.log(styles.ribbon);
            title.setAlignment(styles.ribbon);

            return title;
        }

        const ribbon = new cc.Sprite(bundles.boosttime.frames.purple_ribbon);
        ribbon.addChild(title);
        ribbon.setAlignment(styles.ribbon);

        return ribbon;
    },

    buyPackProduct: function () {
        this.close();

        cleverapps.focusManager.display({
            focus: "RewardWindow",
            stack: true,
            action: (f) => {
                new RewardWindow(this.pack.prizes, { event: cleverapps.EVENTS.EARN.PURCHASE });
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    },

    listBundles: function () {
        return ["boosttime"];
    }
});

BoostTimeMissionWindow.PACK = {
    price: 50,
    prizes: {
        soft: 250
    }
};

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    BOOSTTIMEMISSIONWINDOW_TITLE_TEXT: {
        size: 60,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    BOOSTTIMEMISSIONWINDOW_DESCRIPTION_TEXT: {
        size: 42,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    BOOSTTIMEMISSIONWINDOW_REWARD_TEXT: {
        size: 40,
        name: "default"
    },

    BOOSTTIMEMISSIONWINDOW_BADGE_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    }
});

cleverapps.styles.BoostTimeMissionWindow = {
    width: 1200,
    height: 1000,

    person: "worker",

    contentPadding: {
        left: 200,
        right: 200
    },

    animation: {
        x: { align: "center", dx: -20 },
        y: { align: "center", dy: 0 }
    },

    description: {
        x: { align: "center" },
        y: { align: "center", dy: -400 },
        width: 1200,
        height: 180
    },

    ribbon: {
        x: { align: "right", dx: 260 },
        y: { align: "center", dy: 220 },
        title: {
            x: { align: "center" },
            y: { align: "center", dy: 23 },
            width: 280
        }
    },

    buyPackButton: {
        x: { align: "right", dx: 140 },
        y: { align: "center", dy: -200 },
        width: 230,
        height: 100
    },

    coinsPack: {
        x: { align: "right", dx: 200 },
        y: { align: "center", dy: 30 },

        reward: {
            x: { align: "center", dx: -10 },
            y: { align: "center", dy: -124 }
        },

        badge: {
            x: { align: "center", dx: 145 },
            y: { align: "center", dy: -60 }
        }
    }
};
